import React, { useState, useEffect, useRef } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import axios from "axios";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PersonIcon from '@mui/icons-material/Person';
import Notes from "./header";
import FooterManual from "./footerManual";
import { useParams } from "react-router-dom";
import { Box, Link, Container } from "@mui/material";

// Configure axios instance
const api = axios.create({
  baseURL: "https://car.amar.co.jp/api",
  timeout: 10000,
});

// Same chat WebSocket endpoint the admin side (adminChat.js) uses.
const WS_URL = "https://car.amar.co.jp/api/dashboard/ws-chat";

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Accept"] = "application/json";
    return config;
  },
  (error) => Promise.reject(error)
);

const HistoryTickets = ({ authToken }) => {
  const { shippingCalculationId, orderId } = useParams();

  // orderId param aaya hai toh orderHistory ke View Tickets se aaya hai
  const isOrderFilter = !!orderId;
  const [tickets, setTickets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [updatedStatus, setUpdatedStatus] = useState("");
  const [updatedAssignee, setUpdatedAssignee] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterPriority, setFilterPriority] = useState("all");
  const [filterType, setFilterType] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showReplyChat, setShowReplyChat] = useState(false);
  const [replyMessage, setReplyMessage] = useState("");
  const [sendingMessage, setSendingMessage] = useState(false);
  const [closingTicket, setClosingTicket] = useState(false);
  const [reopeningTicket, setReopeningTicket] = useState(false);
  const [closingInquiryTicket, setClosingInquiryTicket] = useState(false);
  const [reopeningInquiryTicket, setReopeningInquiryTicket] = useState(false);
  const [attachedFile, setAttachedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(isOrderFilter ? "order" : "inquiry");
  const [orderTickets, setOrderTickets] = useState([]);
  const [orderLoading, setOrderLoading] = useState(false);
  const [orderError, setOrderError] = useState(null);
  const [chatMessages, setChatMessages] = useState([]);
  const [loadingChat, setLoadingChat] = useState(false);
  const [chatError, setChatError] = useState(null);
  const [unreadCounts, setUnreadCounts] = useState({});
  const [isDownloading, setIsDownloading] = useState({});
  const [userProfilePic, setUserProfilePic] = useState(null);
  useEffect(() => {
    const cached = localStorage.getItem("profileImageData");
    if (cached) setUserProfilePic(cached);
  }, []);
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const chatEndRef = useRef(null);
  const fileInputRef = useRef(null);
  const orderChatPollingRef = useRef(null);   // Order Chat OPEN -- messages fetch
  const orderBadgePollingRef = useRef(null);  // Order Chat BAND -- badge fetch
  const inquiryChatPollingRef = useRef(null); // Inquiry Chat OPEN -- messages fetch
  const inquiryBadgePollingRef = useRef(null);// Inquiry Chat BAND -- badge fetch
  const lastSeenOrderChatIdRef = useRef(null);
  const lastSeenInquiryChatIdRef = useRef(null);
  const stompClientRef = useRef(null);
  const ticketSubRef = useRef(null);
  const userNotifSubRef = useRef(null);
  const [wsConnected, setWsConnected] = useState(false);

  const agents = ["Agent A", "Agent B", "Agent C", "Unassigned"];

  const handleSort = (field) => {
    if (sortField === field) {
      if (sortDirection === "asc") {
        setSortDirection("desc");
      } else {
        setSortField(null);
        setSortDirection("asc");
      }
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
    setCurrentPage(1);
  };

  const applySort = (data) => {
    if (!sortField) return data;
    const priorityOrder = { urgent: 1, high: 2, medium: 3, low: 4 };
    const statusOrder = { open: 1, "in-progress": 2, "re-open": 3, closed: 4 };
    return [...data].sort((a, b) => {
      let aVal = a[sortField];
      let bVal = b[sortField];
      if (sortField === "priority") {
        aVal = priorityOrder[a.priority?.toLowerCase()] || 99;
        bVal = priorityOrder[b.priority?.toLowerCase()] || 99;
        return sortDirection === "asc" ? aVal - bVal : bVal - aVal;
      }
      if (sortField === "status") {
        aVal = statusOrder[a.status?.toLowerCase()] || 99;
        bVal = statusOrder[b.status?.toLowerCase()] || 99;
        return sortDirection === "asc" ? aVal - bVal : bVal - aVal;
      }
      if (sortField === "date") {
        return sortDirection === "asc"
          ? new Date(aVal) - new Date(bVal)
          : new Date(bVal) - new Date(aVal);
      }
      aVal = (aVal || "").toString().toLowerCase();
      bVal = (bVal || "").toString().toLowerCase();
      if (aVal < bVal) return sortDirection === "asc" ? -1 : 1;
      if (aVal > bVal) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return <span style={{ opacity: 1, marginLeft: "4px", fontSize: "10px", color: "white" }}>▲▼</span>;
    return <span style={{ marginLeft: "4px", fontSize: "11px", color: "white" }}>{sortDirection === "asc" ? "▲" : "▼"}</span>;
};

  const isUserRole = (role) => {
    if (!role) return false;
    const r = role.toUpperCase().replace(/[\s_-]/g, "");
    return r === "USER" || r === "CUSTOMER";
  };

  const renderActorBadge = (name, role, color) => {
    if (!name) return null;
    const isUser = isUserRole(role);
    return (
      <div style={{ marginTop: "4px", fontSize: "11px", color, fontWeight: "600", whiteSpace: "nowrap", display: "flex", alignItems: "center", justifyContent: "center", gap: "3px" }}>
        {isUser ? (
          userProfilePic ? (
            <img src={userProfilePic} alt="user" style={{ width: "24px", height: "24px", borderRadius: "50%", objectFit: "cover" }} />
          ) : (
            <PersonIcon style={{ fontSize: "14px" }} />
          )
        ) : (
          <SupportAgentIcon style={{ fontSize: "14px" }} />
        )}
        {name}
      </div>
    );
  };

  const getAuthToken = () => {
    return authToken || localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
  };

  const transformTicketData = (apiTicket) => {
    // Status mapping -- handle REOPEN enum + fallback
    const getStatus = () => {
      const s = apiTicket.ticketStatus?.toUpperCase();
      if (s === "REOPEN" || s === "RE_OPEN" || s === "RE-OPEN") return "re-open";
      if (s === "OPEN" && (apiTicket.ticketReopenBy || apiTicket.ticketReopenByName)) return "re-open";
      if (s === "IN_PROGRESS") return "in-progress";
      if (s === "CLOSED") return "closed";
      if (s === "OPEN") return "open";
      // Fallback to ticketStatusDisplay
      return apiTicket.ticketStatusDisplay
        ? apiTicket.ticketStatusDisplay.toLowerCase()
        : "open";
    };

    return {
      id: apiTicket.raiseTicketId,
      ticketNumber: apiTicket.ticketNumber,
      userId: apiTicket.userId,
      subject: apiTicket.subject,
      description: apiTicket.message,
      type: mapCategoryToType(apiTicket.category),
      status: getStatus(),
      date: convertDate(apiTicket.lastActivityAt || apiTicket.creationDate),
      createdDate: convertDate(apiTicket.creationDate),
      priority: apiTicket.ticketPriorityDisplay
        ? apiTicket.ticketPriorityDisplay.toLowerCase()
        : apiTicket.priority
        ? apiTicket.priority.toLowerCase()
        : "medium",
      userName: `${apiTicket.userFirstName} ${apiTicket.userLastName}`,
      userEmail: apiTicket.userEmail || "--",
      carModel: apiTicket.carModelName || "N/A",
      category: apiTicket.category,
      ticketCategoryDisplay: apiTicket.ticketCategoryDisplay,
      ticketPriorityDisplay: apiTicket.ticketPriorityDisplay,
      attachmentPath: apiTicket.attachmentPath,
      attachmentFileName: apiTicket.attachmentFileName,
      shippingCalculationId: apiTicket.shippingCalculationId,
      inquiryRefNumber: apiTicket.inquiryRefNumber,
      alternativeMobileNumber: apiTicket.alternativeMobileNumber,
      countryCode: apiTicket.countryCode,
      reopenCount: apiTicket.reopenCount || 0,
      lastActivityAt: apiTicket.lastActivityAt || null,
      replies: 0,
      assignedTo: "Unassigned",
      isRead: apiTicket.isRead,
      ticketClosedBy: apiTicket.ticketClosedByName || apiTicket.ticketClosedBy || null,
      ticketClosedByRole: apiTicket.ticketClosedBy || null,
      ticketClosedAt: apiTicket.ticketClosedAt || null,
      reopenedBy: apiTicket.ticketReopenByName || apiTicket.ticketReopenBy || null,
      reopenedByRole: apiTicket.ticketReopenBy || null,
      ticketReopenAt: apiTicket.ticketReopenAt || null,
    };
  };

  const mapCategoryToType = (category) => {
    const categoryMap = {
      GENERAL_INQUIRY: "inquiry",
      TECHNICAL_ISSUE: "technical",
      BILLING_QUESTION: "billing",
      FEEDBACK_SUGGESTION: "feedback",
      ORDER_ISSUE: "order",
    };
    return categoryMap[category] || "inquiry";
  };

  const convertDate = (dateString) => {
    try {
      const [date, time] = dateString.split(" ");
      const [day, month, year] = date.split("-");
      // Append Z to treat as UTC and avoid timezone shift
      return time ? `${year}-${month}-${day}T${time}Z` : `${year}-${month}-${day}`;
    } catch (e) {
      return new Date().toISOString().split("T")[0];
    }
  };

  useEffect(() => {
    fetchTickets();

    if (isOrderFilter) {
      fetchOrderTicketsByOrderId(orderId);
    } else if (!shippingCalculationId) {
      fetchOrderTickets();
    }
  }, []);

  // --- WebSocket: connect once for the whole component's lifetime ----------
  // Actual per-ticket topic subscription happens in handleOpenChat/handleCloseChat.
  useEffect(() => {
    const token = getAuthToken();
    const client = new Client({
      webSocketFactory: () => {
        const url = token ? `${WS_URL}?token=${encodeURIComponent(token)}` : WS_URL;
        return new SockJS(url);
      },
      connectHeaders: token ? { Authorization: `Bearer ${token}` } : {},
      reconnectDelay: 5000,
    });

    client.onConnect = () => {
      console.log("[Chat WS] Connected to", WS_URL);
      setWsConnected(true);
    };
    client.onWebSocketClose = () => setWsConnected(false);
    client.onStompError = (frame) => console.error("[Chat WS] STOMP error:", frame);

    client.activate();
    stompClientRef.current = client;

    return () => {
      client.deactivate();
      stompClientRef.current = null;
    };
  }, []);

  // --- WebSocket: subscribe to this user's own notification topic, once we
  // know the userId (from whichever ticket list loads first) ---------------
  useEffect(() => {
    if (userNotifSubRef.current) return; // already subscribed
    if (!wsConnected || !stompClientRef.current || !stompClientRef.current.connected) return;

    const userId = tickets[0]?.userId ?? orderTickets[0]?.userId;
    if (!userId) return;

    userNotifSubRef.current = stompClientRef.current.subscribe(
      `/topic/user-chat-notifications/${userId}`,
      (frame) => {
        console.log("[Chat WS] /topic/user-chat-notifications frame:", frame.body);
        let payload;
        try { payload = JSON.parse(frame.body); } catch { return; }
        const ticketNumber = payload.ticketNumber ?? payload.orderTicketNumber;
        if (ticketNumber) fetchUnreadCount(ticketNumber);
      }
    );
  }, [wsConnected, tickets, orderTickets]);

  // --- Cleanup on unmount -------------------------------------------------------
  useEffect(() => {
    return () => {
      if (orderChatPollingRef.current) clearInterval(orderChatPollingRef.current);
      if (orderBadgePollingRef.current) clearInterval(orderBadgePollingRef.current);
      if (inquiryChatPollingRef.current) clearInterval(inquiryChatPollingRef.current);
      if (inquiryBadgePollingRef.current) clearInterval(inquiryBadgePollingRef.current);
      if (userNotifSubRef.current) {
        try { userNotifSubRef.current.unsubscribe(); } catch { /* stale sub */ }
        userNotifSubRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatMessages]);

  useEffect(() => {
    if (tickets.length > 0) {
      tickets.forEach((ticket) => {
        fetchUnreadCount(ticket.ticketNumber);
      });
    }
  }, [tickets.length]);

  useEffect(() => {
    if (orderTickets.length > 0) {
      orderTickets.forEach((ticket) => {
        fetchUnreadCount(ticket.ticketNumber);
      });
    }
  }, [orderTickets.length]);

  const fetchTickets = async () => {
    const token = getAuthToken();
    if (!token) {
      setError("Authentication token not found. Please login first.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      let ticketsArray = [];

      if (shippingCalculationId) {
        // inquiryHistory se aaya hai -- shippingCalculationId ke basis pe filter karo
        const response = await api.get(
          `/dashboard/raise-ticket/get-all-tickets/by-shippingCalculationId`,
          { params: { shippingCalculationId } }
        );
        // Response: { success, shippingCalculationId, totalTickets, data: [...] }
        if (response.data.success && Array.isArray(response.data.data)) {
          ticketsArray = response.data.data;
        } else {
          throw new Error("Invalid response format");
        }
      } else {
        // Normal user tickets
        const response = await api.get("/dashboard/raise-ticket/get-user-tickets/by-userId");
        // Response: { success, message, totalCount, tickets: [...] }
        if (response.data.success && Array.isArray(response.data.tickets)) {
          ticketsArray = response.data.tickets;
        } else {
          throw new Error("Invalid response format");
        }
      }

      const transformedTickets = ticketsArray.map(transformTicketData);
      setTickets(transformedTickets);
      transformedTickets.forEach((ticket) => {
        fetchUnreadCount(ticket.ticketNumber);
      });
    } catch (err) {
      console.error("Error fetching tickets:", err);
      setError(err.message || "Failed to load tickets. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const transformOrderTicketData = (apiTicket) => {
    const getStatus = () => {
      const s = apiTicket.ticketStatus?.toUpperCase().replace(/[-_\s]/g, "");
      if (s === "REOPEN") return "re-open";
      if (s === "OPEN" && (apiTicket.ticketReopenBy || apiTicket.ticketReopenByName)) return "re-open";
      if (s === "OPEN") return "open";
      if (s === "INPROGRESS") return "in-progress";
      if (s === "CLOSED") return "closed";
      return apiTicket.ticketStatusDisplay?.toLowerCase() || "open";
    };

    return {
      id: apiTicket.orderRaiseTicketId,
      ticketNumber: apiTicket.orderTicketNumber,
      userId: apiTicket.userId,
      subject: apiTicket.ticketSubject,
      description: apiTicket.ticketDescription,
      type: apiTicket.ticketCategoryDisplay || apiTicket.ticketCategory,
      status: getStatus(),
      date: convertDate(apiTicket.lastActivityAt || apiTicket.creationDate),
      createdDate: convertDate(apiTicket.creationDate),
      priority: apiTicket.ticketPriorityDisplay?.toLowerCase() || "medium",
      userName: `${apiTicket.userFirstName} ${apiTicket.userLastName}`,
      userEmail: `${apiTicket.userEmail}`,
      carModel: apiTicket.carModelName,
      orderRefId: apiTicket.orderRefId,
      attachmentPath: apiTicket.attachmentPath,
      attachmentFileName: apiTicket.attachmentFileName,
      isRead: apiTicket.isRead,
      ticketClosedBy: apiTicket.ticketClosedByName || apiTicket.ticketClosedBy || null,
      ticketClosedByRole: apiTicket.ticketClosedBy || null,
      ticketClosedAt: apiTicket.ticketClosedAt || null,
      reopenedBy: apiTicket.ticketReopenByName || apiTicket.ticketReopenBy || null,
      reopenedByRole: apiTicket.ticketReopenBy || null,
      ticketReopenAt: apiTicket.ticketReopenAt || null,
      reopenCount: apiTicket.reopenCount || 0,
      lastActivityAt: apiTicket.lastActivityAt || null,
    };
  };

  const fetchOrderTickets = async () => {
    const token = getAuthToken();
    if (!token) {
      setOrderError("Authentication token not found. Please login first.");
      return;
    }
    setOrderLoading(true);
    setOrderError(null);
    try {
      const response = await api.get("/dashboard/order-ticket/get-user-tickets/by-userId");
      if (response.data.success && response.data.data) {
        const transformed = response.data.data.map(transformOrderTicketData);
        setOrderTickets(transformed);
      } else {
        throw new Error("Invalid response format");
      }
    } catch (err) {
      console.error("Error fetching order tickets:", err);
      setOrderError(err.message || "Failed to load order tickets. Please try again.");
    } finally {
      setOrderLoading(false);
    }
  };

  // Specific order ke tickets fetch karo (orderHistory ke View Tickets se)
  const fetchOrderTicketsByOrderId = async (orderId) => {
    const token = getAuthToken();
    if (!token) {
      setOrderError("Authentication token not found. Please login first.");
      return;
    }
    setOrderLoading(true);
    setOrderError(null);
    try {
      const response = await api.get(
        `/dashboard/order-ticket/get-all-tickets/by-orderId?calculationOrderHistoryId=${orderId}`
      );
      if (response.data.success && response.data.data) {
        const transformed = response.data.data.map(transformOrderTicketData);
        setOrderTickets(transformed);
      } else {
        setOrderTickets([]);
      }
    } catch (err) {
      console.error("Error fetching order tickets by orderId:", err);
      setOrderError(err.message || "Failed to load order tickets.");
    } finally {
      setOrderLoading(false);
    }
  };

  const fetchUnreadCount = async (ticketNumber) => {
    try {
      const isOrderTicket = ticketNumber?.startsWith("ORT-");
      const endpoint = isOrderTicket
        ? `/dashboard/order-ticket-chat/unread-count/${ticketNumber}`
        : `/dashboard/inquiry-chat/unread-count/${ticketNumber}`;

      const response = await api.get(endpoint);

      if (response.data.success) {
        setUnreadCounts((prev) => ({
          ...prev,
          [ticketNumber]: response.data.unreadCount,
        }));
      }
    } catch (err) {
      console.error("Error fetching unread count:", err);
    }
  };

  const fetchChatHistory = async (ticketNumber) => {
    setLoadingChat(true);
    setChatError(null);

    try {
      const response = await api.get(
        `/dashboard/inquiry-chat/history/${ticketNumber}`
      );

      const messages = Array.isArray(response.data) ? response.data : [];
      setChatMessages(messages);
      return messages;
    } catch (err) {
      console.error("Error fetching chat history:", err);
      setChatError(err.message || "Failed to load chat history.");
      return [];
    } finally {
      setLoadingChat(false);
    }
  };

  const fetchOrderChatHistory = async (ticketNumber) => {
    setLoadingChat(true);
    setChatError(null);

    try {
      const response = await api.get(
        `/dashboard/order-ticket-chat/history-by/${ticketNumber}`
      );

      const messages = Array.isArray(response.data) ? response.data : [];
      // Normalize orderChatId -> chatId to match existing chat UI
      const normalized = messages.map((msg) => ({
        ...msg,
        chatId: msg.orderChatId ?? msg.chatId,
      }));
      setChatMessages(normalized);
      return normalized;
    } catch (err) {
      console.error("Error fetching order chat history:", err);
      setChatError(err.message || "Failed to load chat history.");
      return [];
    } finally {
      setLoadingChat(false);
    }
  };

  const markMessagesAsRead = async (ticketNumber) => {
    try {
      const isOrderTicket = ticketNumber?.startsWith("ORT-");

      if (isOrderTicket) {
        await api.put(`/dashboard/order-ticket-chat/mark-read/${ticketNumber}`);
      } else {
        await api.put(`/dashboard/inquiry-chat/mark-read/${ticketNumber}`);
      }
      // Fix: just reset unread count locally -- no need to re-fetch entire history
      setUnreadCounts((prev) => ({ ...prev, [ticketNumber]: 0 }));
    } catch (error) {
      console.error("Error marking messages as read:", error);
    }
  };

  const handleDownloadAttachment = async (chatId, fileName, isOrderTicket = false) => {
    try {
      setIsDownloading((prev) => ({ ...prev, [chatId]: true }));
      const token = getAuthToken();

      if (!token) {
        setSuccessMessage("Authentication token not found. Please login again.");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 4000);
        setIsDownloading((prev) => ({ ...prev, [chatId]: false }));
        return;
      }

      const downloadEndpoint = isOrderTicket
        ? `https://car.amar.co.jp/api/dashboard/order-ticket-chat/download/${chatId}`
        : `https://car.amar.co.jp/api/dashboard/inquiry-chat/download/${chatId}`;

      const response = await fetch(downloadEndpoint, {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 404) {
        setSuccessMessage("No attachment found for this message.");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 4000);
        setIsDownloading((prev) => ({ ...prev, [chatId]: false }));
        return;
      }

      if (!response.ok) {
        let msg = `Download failed: ${response.statusText}`;
        if (response.status === 401) msg = "Your session has expired. Please login again.";
        else if (response.status === 403) msg = "You don't have permission to download this file.";
        setSuccessMessage(msg);
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 4000);
        setIsDownloading((prev) => ({ ...prev, [chatId]: false }));
        return;
      }

      const blob = await response.blob();

      if (blob.size === 0) {
        setSuccessMessage("Downloaded file is empty.");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 4000);
        setIsDownloading((prev) => ({ ...prev, [chatId]: false }));
        return;
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "attachment";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      setSuccessMessage(`${fileName} downloaded successfully!`);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);

      setIsDownloading((prev) => ({ ...prev, [chatId]: false }));
    } catch (error) {
      console.error("Error downloading attachment:", error);
      setSuccessMessage(`Failed to download: ${error.message}`);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 4000);
      setIsDownloading((prev) => ({ ...prev, [chatId]: false }));
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      resolved: "#e8f5e9",
      "in-progress": "#e3f2fd",
      "in_progress": "#e3f2fd",
      open: "#fff3e0",
      pending: "#ffebee",
      closed: "#4caf50",
      "re-open": "#9c27b0",
      reopen: "#9c27b0",
    };
    return colors[status] || "#f5f5f5";
  };

  const getStatusTextColor = (status) => {
    const colors = {
      resolved: "#2e7d32",
      "in-progress": "#1976d2",
      "in_progress": "#1976d2",
      open: "#e65100",
      pending: "#c62828",
      closed: "white",
      "re-open": "white",
      reopen: "white",
    };
    return colors[status] || "#333";
  };

  const getPriorityColor = (priority) => {
    const p = priority?.toLowerCase() || "";
    if (p === "high" || p === "urgent") return "#f44336";
    if (p === "medium") return "#ff9800";
    if (p === "low") return "#4caf50";
    return "#666";
  };

  const getTypeText = (type) => {
    const typeMap = {
      order: "Order Issue",
      inquiry: "Inquiry",
      technical: "Technical",
      billing: "Billing",
      feedback: "Feedback",
    };
    return typeMap[type] || "Inquiry";
  };

  const getOrderTypeBadgeStyle = (type) => {
    const t = (type || "").toLowerCase();
    if (t.includes("return")) return { backgroundColor: "#fff3e0", color: "#e65100" };
    if (t.includes("product")) return { backgroundColor: "#fce4ec", color: "#c62828" };
    if (t.includes("technical")) return { backgroundColor: "#e8f5e9", color: "#2e7d32" };
    if (t.includes("billing")) return { backgroundColor: "#fff8e1", color: "#f57f17" };
    if (t.includes("feedback")) return { backgroundColor: "#e8f5e9", color: "#2e7d32" };
    if (t.includes("inquiry")) return { backgroundColor: "#e3f2fd", color: "#1976d2" };
    if (t.includes("other")) return { backgroundColor: "#f3e5f5", color: "#6a1b9a" };
    return { backgroundColor: "#e3f2fd", color: "#1976d2" };
  };

  const handleCloseOrderTicket = async () => {
    if (!selectedTicket) return;
    setClosingTicket(true);
    try {
      const response = await api.put(
        `/dashboard/order-ticket/close?orderTicketNumber=${selectedTicket.ticketNumber}`
      );
      if (response.status === 200 || response.data.success) {
        const closedByName = response.data?.data?.ticketClosedByName || response.data?.closedBy || null;
        setOrderTickets((prev) =>
          prev.map((t) =>
            t.ticketNumber === selectedTicket.ticketNumber
              ? { ...t, status: "closed", ticketClosedBy: closedByName || t.ticketClosedBy }
              : t
          )
        );
        setSelectedTicket((prev) => ({
          ...prev,
          status: "closed",
          ticketClosedBy: closedByName || prev.ticketClosedBy,
        }));
        setSuccessMessage("Ticket closed successfully!");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        throw new Error(response.data.message || "Failed to close ticket");
      }
    } catch (err) {
      console.error("Error closing ticket:", err);
      setSuccessMessage("Failed to close ticket. Please try again.");
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } finally {
      setClosingTicket(false);
    }
  };

  const handleReopenOrderTicket = async () => {
    if (!selectedTicket) return;
    setReopeningTicket(true);
    try {
      const response = await api.put(
        `/dashboard/order-ticket/reopen?orderTicketNumber=${selectedTicket.ticketNumber}`
      );
      if (response.status === 200 || response.data.success) {
        const reopenedByName = response.data?.data?.ticketReopenByName || response.data?.reopenedBy || null;
        setOrderTickets((prev) =>
          prev.map((t) =>
            t.ticketNumber === selectedTicket.ticketNumber
              ? { ...t, status: "re-open", reopenedBy: reopenedByName || t.reopenedBy, ticketClosedBy: null, ticketClosedAt: null }
              : t
          )
        );
        setSelectedTicket((prev) => ({
          ...prev,
          status: "re-open",
          reopenedBy: reopenedByName || prev.reopenedBy,
          ticketClosedBy: null,
          ticketClosedAt: null,
        }));
        setSuccessMessage("Ticket reopened successfully!");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        throw new Error(response.data.message || "Failed to reopen ticket");
      }
    } catch (err) {
      console.error("Error reopening ticket:", err);
      setSuccessMessage("Failed to reopen ticket. Please try again.");
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } finally {
      setReopeningTicket(false);
    }
  };

  // Close Inquiry Ticket Handler
  const handleCloseInquiryTicket = async () => {
    if (!selectedTicket) return;
    setClosingInquiryTicket(true);
    try {
      const token = getAuthToken();
      const response = await fetch(
        `https://car.amar.co.jp/api/dashboard/raise-ticket/close?ticketNumber=${selectedTicket.ticketNumber}`,
        {
          method: "PUT",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) throw new Error(`API error: ${response.status}`);
      const data = await response.json();
      if (data.success) {
        const closedByName = data.data?.ticketClosedByName || data.closedBy || null;
        setTickets((prev) =>
          prev.map((t) =>
            t.ticketNumber === selectedTicket.ticketNumber
              ? { ...t, status: "closed", ticketClosedBy: closedByName || t.ticketClosedBy, ticketClosedAt: data.closedAt || data.data?.ticketClosedAt }
              : t
          )
        );
        setSelectedTicket((prev) => ({
          ...prev,
          status: "closed",
          ticketClosedBy: closedByName || prev.ticketClosedBy,
          ticketClosedAt: data.closedAt || data.data?.ticketClosedAt,
        }));
        setSuccessMessage("Ticket closed successfully!");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        throw new Error(data.message || "Failed to close ticket");
      }
    } catch (err) {
      console.error("Error closing inquiry ticket:", err);
      setSuccessMessage("Failed to close ticket. Please try again.");
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } finally {
      setClosingInquiryTicket(false);
    }
  };

  // Reopen Inquiry Ticket Handler
  const handleReopenInquiryTicket = async () => {
    if (!selectedTicket) return;
    setReopeningInquiryTicket(true);
    try {
      const token = getAuthToken();
      const response = await fetch(
        `https://car.amar.co.jp/api/dashboard/raise-ticket/reopen?ticketNumber=${selectedTicket.ticketNumber}`,
        {
          method: "PUT",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) throw new Error(`API error: ${response.status}`);
      const data = await response.json();
      if (data.success) {
        const reopenedByName = data.data?.ticketReopenByName || data.reopenedBy || null;
        setTickets((prev) =>
          prev.map((t) =>
            t.ticketNumber === selectedTicket.ticketNumber
              ? { ...t, status: "re-open", reopenedBy: reopenedByName || t.reopenedBy, ticketClosedBy: null, ticketClosedAt: null }
              : t
          )
        );
        setSelectedTicket((prev) => ({
          ...prev,
          status: "re-open",
          reopenedBy: reopenedByName || prev.reopenedBy,
          ticketClosedBy: null,
          ticketClosedAt: null,
        }));
        setSuccessMessage("Ticket reopened successfully!");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        throw new Error(data.message || "Failed to reopen ticket");
      }
    } catch (err) {
      console.error("Error reopening inquiry ticket:", err);
      setSuccessMessage("Failed to reopen ticket. Please try again.");
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } finally {
      setReopeningInquiryTicket(false);
    }
  };

  const handleCloseDetailsDialog = () => {
    setShowDetails(false);
    setSelectedTicket(null);
  };

  const handleOpenChat = async (ticket) => {
    setSelectedTicket(ticket);
    setShowReplyChat(true);
    setAttachedFile(null);
    setReplyMessage("");
    setChatMessages([]);
    if (fileInputRef.current) fileInputRef.current.value = "";

    const isOrderTicket = ticket.ticketNumber?.startsWith("ORT-") || ticket.orderRefId !== undefined;
    if (isOrderTicket) {
      const initialMessages = await fetchOrderChatHistory(ticket.ticketNumber);
      lastSeenOrderChatIdRef.current = initialMessages[initialMessages.length - 1]?.chatId ?? null;
    } else {
      const initialMessages = await fetchChatHistory(ticket.ticketNumber);
      lastSeenInquiryChatIdRef.current = initialMessages[initialMessages.length - 1]?.chatId ?? null;
    }
    await markMessagesAsRead(ticket.ticketNumber);

    // Live updates via WebSocket instead of REST polling — same
    // /topic/chat/{ticketNumber} topic used on the admin side.
    if (ticketSubRef.current) {
      try { ticketSubRef.current.unsubscribe(); } catch { /* stale sub */ }
      ticketSubRef.current = null;
    }
    if (stompClientRef.current && stompClientRef.current.connected) {
      ticketSubRef.current = stompClientRef.current.subscribe(
        `/topic/chat/${ticket.ticketNumber}`,
        (frame) => {
          let payload;
          try { payload = JSON.parse(frame.body); } catch { return; }

          // 1) READ_RECEIPT — admin just read OUR messages, flip our own
          //    sent-message ticks blue. Not a chat bubble.
          if (payload.eventType === "READ_RECEIPT") {
            const readBy = (payload.readBySenderType || "").toUpperCase();
            if (readBy === "ADMIN" || readBy === "SUPERADMIN") {
              setChatMessages((prev) =>
                prev.map((m) => (m.senderType === "USER" ? { ...m, isRead: true } : m))
              );
            }
            return;
          }

          // 2) Normal chat message DTO.
          const normalized = { ...payload, chatId: payload.orderChatId ?? payload.chatId };
          if (isOrderTicket) lastSeenOrderChatIdRef.current = normalized.chatId;
          else lastSeenInquiryChatIdRef.current = normalized.chatId;

          setChatMessages((prev) =>
            prev.some((m) => m.chatId === normalized.chatId) ? prev : [...prev, normalized]
          );

          // This chat is open right now, so an incoming ADMIN/SUPERADMIN
          // message should immediately count as read — don't wait for the
          // chat to be closed/reopened.
          if (normalized.senderType !== "USER") {
            markMessagesAsRead(ticket.ticketNumber);
          }
        }
      );
    }
  };

  useEffect(() => {
    if (!wsConnected || !showReplyChat || !selectedTicket || ticketSubRef.current) return;
    if (!stompClientRef.current || !stompClientRef.current.connected) return;

    const isOrderTicket = selectedTicket.ticketNumber?.startsWith("ORT-") || selectedTicket.orderRefId !== undefined;
    ticketSubRef.current = stompClientRef.current.subscribe(
      `/topic/chat/${selectedTicket.ticketNumber}`,
      (frame) => {
        let payload;
        try { payload = JSON.parse(frame.body); } catch { return; }

        if (payload.eventType === "READ_RECEIPT") {
          const readBy = (payload.readBySenderType || "").toUpperCase();
          if (readBy === "ADMIN" || readBy === "SUPERADMIN") {
            setChatMessages((prev) =>
              prev.map((m) => (m.senderType === "USER" ? { ...m, isRead: true } : m))
            );
          }
          return;
        }

        const normalized = { ...payload, chatId: payload.orderChatId ?? payload.chatId };
        if (isOrderTicket) lastSeenOrderChatIdRef.current = normalized.chatId;
        else lastSeenInquiryChatIdRef.current = normalized.chatId;

        setChatMessages((prev) =>
          prev.some((m) => m.chatId === normalized.chatId) ? prev : [...prev, normalized]
        );

        if (normalized.senderType !== "USER") {
          markMessagesAsRead(selectedTicket.ticketNumber);
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wsConnected, showReplyChat, selectedTicket]);

  const handleCloseChat = () => {
    // Chat band karne se pehle messages read mark karo
    if (selectedTicket) {
      markMessagesAsRead(selectedTicket.ticketNumber);
    }
    // WebSocket subscription band karo
    if (ticketSubRef.current) {
      try { ticketSubRef.current.unsubscribe(); } catch { /* stale sub */ }
      ticketSubRef.current = null;
    }
    // Chat polling band karo -- order aur inquiry dono (legacy safety net)
    if (orderChatPollingRef.current) {
      clearInterval(orderChatPollingRef.current);
      orderChatPollingRef.current = null;
    }
    if (inquiryChatPollingRef.current) {
      clearInterval(inquiryChatPollingRef.current);
      inquiryChatPollingRef.current = null;
    }
    lastSeenOrderChatIdRef.current = null;
    lastSeenInquiryChatIdRef.current = null;
    setShowReplyChat(false);
    setSelectedTicket(null);
    setChatMessages([]);
    setReplyMessage("");
    setAttachedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert("File size must be less than 5MB");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }
      setAttachedFile(file);
    }
  };

  const handleSendReply = async () => {
    if (!replyMessage.trim() && !attachedFile) return;

    setSendingMessage(true);

    try {
      if (!selectedTicket) {
        throw new Error("No ticket selected");
      }

      const isOrderTicket = selectedTicket.ticketNumber?.startsWith("ORT-") || selectedTicket.orderRefId !== undefined;

      const formData = new FormData();

      if (attachedFile) {
        formData.append("attachment", attachedFile);
      } else {
        formData.append("attachment", new Blob(), "");
      }

      let response;
      if (isOrderTicket) {
        response = await api.post("/dashboard/order-ticket-chat/send", formData, {
          params: {
            orderTicketNumber: selectedTicket.ticketNumber,
            message: replyMessage,
          },
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        response = await api.post("/dashboard/inquiry-chat/send", formData, {
          params: {
            ticketNumber: selectedTicket.ticketNumber,
            message: replyMessage,
          },
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      if (response.data.success) {
        const sent = response.data.chatData;
        // Fix: optimistic local push instead of re-fetching entire history
        const newMsg = {
          chatId: sent.orderChatId ?? sent.chatId,
          message: sent.message,
          senderType: "USER",
          senderFullName: sent.senderFullName || "You",
          attachmentFileName: sent.attachmentFileName,
          formattedDateTime: sent.formattedDateTime,
          isRead: false,
        };
        setChatMessages((prev) =>
          prev.some((m) => m.chatId === newMsg.chatId) ? prev : [...prev, newMsg]
        );

        // Update ticket date locally so sort reflects latest activity without refresh
        const updatedDate = sent.formattedDateTime || new Date().toISOString();
        if (isOrderTicket) {
          setOrderTickets((prev) =>
            prev.map((t) =>
              t.ticketNumber === selectedTicket.ticketNumber ? { ...t, date: updatedDate } : t
            )
          );
        } else {
          setTickets((prev) =>
            prev.map((t) =>
              t.ticketNumber === selectedTicket.ticketNumber ? { ...t, date: updatedDate } : t
            )
          );
        }
        setSelectedTicket((prev) => prev ? { ...prev, date: updatedDate } : prev);

        setReplyMessage("");
        setAttachedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";

        setSuccessMessage("Message sent successfully!");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        throw new Error(response.data.message || "Failed to send message");
      }
    } catch (err) {
      console.error("Error submitting reply:", err);
      setSuccessMessage("Failed to send: " + (err.response?.data?.message || err.message));
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 4000);
    } finally {
      setSendingMessage(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "--";
    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", hour12: false };
    return date.toLocaleString("en-GB", options);
  };

  const formatChatTime = (dateString) => {
    if (!dateString) return "Just now";
    const date = new Date(dateString);
    const options = { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", hour12: false };
    return date.toLocaleString("en-GB", options);
  };

  const getClosedByLabel = (closedBy) => {
    if (!closedBy) return null;
    const val = closedBy.toUpperCase();
    if (val.includes("AUTO") || val.includes("SYSTEM")) return { label: "Auto", color: "#757575" };
    if (val.includes("USER") || val.includes("CUSTOMER")) return { label: "User", color: "#1976d2" };
    return { label: "Admin", color: "#d32f2f" };
  };

  const getSenderColor = (senderType) => {
    if (senderType === "ADMIN") return "#1976d2";
    if (senderType === "SUPERADMIN") return "#d32f2f";
    if (senderType === "USER") return "#666";
    return "#666";
  };

  const getSenderBgColor = (senderType) => {
    if (senderType === "ADMIN") return "#e3f2fd";
    if (senderType === "SUPERADMIN") return "#ffebee";
    if (senderType === "USER") return "#e3f2fd";
    return "#f5f5f5";
  };

  // Message read/delivered indicator for user's own messages
  const getMessageStatusIndicator = (msg) => {
    if (msg.senderType !== "USER") return null;
    if (msg.isRead === true) {
      return <span style={{ color: "#1976d2", fontSize: "12px", fontWeight: "bold" }} title="Read">vv</span>;
    }
    return <span style={{ color: "#999", fontSize: "12px", fontWeight: "bold" }} title="Delivered">vv</span>;
  };

  const filteredTickets = tickets.filter((ticket) => {
    const matchStatus = filterStatus === "all" || ticket.status === filterStatus ||
      (filterStatus === "re-open" && (ticket.status === "re-open" || ticket.status === "reopen"));
    const matchPriority =
      filterPriority === "all" ||
      ticket.priority.toLowerCase() === filterPriority.toLowerCase();
    const matchType = filterType === "all" || ticket.type === filterType;
    const matchSearch =
      searchText === "" ||
      ticket.ticketNumber.toLowerCase().includes(searchText.toLowerCase()) ||
      ticket.subject.toLowerCase().includes(searchText.toLowerCase()) ||
      ticket.userName.toLowerCase().includes(searchText.toLowerCase());

    return matchStatus && matchPriority && matchType && matchSearch;
  }).sort((a, b) => {
    const aUnread = (unreadCounts[a.ticketNumber] || 0) > 0 ? 1 : 0;
    const bUnread = (unreadCounts[b.ticketNumber] || 0) > 0 ? 1 : 0;
    if (bUnread !== aUnread) return bUnread - aUnread;
    // Secondary: latest activity first
    return new Date(b.date) - new Date(a.date);
  });

  const sortedFilteredTickets = applySort(filteredTickets);

  const filteredOrderTickets = orderTickets.filter((ticket) => {
    const matchStatus = filterStatus === "all" || ticket.status === filterStatus;
    const matchPriority =
      filterPriority === "all" ||
      ticket.priority.toLowerCase() === filterPriority.toLowerCase();
    const matchSearch =
      searchText === "" ||
      ticket.ticketNumber.toLowerCase().includes(searchText.toLowerCase()) ||
      ticket.subject.toLowerCase().includes(searchText.toLowerCase()) ||
      ticket.userName.toLowerCase().includes(searchText.toLowerCase());
    return matchStatus && matchPriority && matchSearch;
  }).sort((a, b) => {
    const aUnread = (unreadCounts[a.ticketNumber] || 0) > 0 ? 1 : 0;
    const bUnread = (unreadCounts[b.ticketNumber] || 0) > 0 ? 1 : 0;
    if (bUnread !== aUnread) return bUnread - aUnread;
    // Secondary: latest activity first
    return new Date(b.date) - new Date(a.date);
  });

  const sortedFilteredOrderTickets = applySort(filteredOrderTickets);

  const totalPages = Math.ceil(
    (activeTab === "inquiry" ? sortedFilteredTickets.length : sortedFilteredOrderTickets.length) / itemsPerPage
  );
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedTickets = sortedFilteredTickets.slice(startIndex, startIndex + itemsPerPage);
  const paginatedOrderTickets = sortedFilteredOrderTickets.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div style={{ width: "100%", backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
      <Notes />
      {/* Hero Banner */}
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: { xs: "30vh", sm: "40vh", md: "50vh" },
                backgroundColor: "black",
                overflow: "hidden",
              }}
            >
              <Box
                component="img"
                src="/image/shutterstock.png"
                alt="banner"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  opacity: 0.57,
                }}
              />
      
              {/* Breadcrumb */}
              <Box
                sx={{
                  position: "absolute",
                  top: { xs: "5%", sm: "5%", md: "5%" },
                  left: { xs: "3%", sm: "5%", md: "5%" },
                  color: "white",
                  fontSize: { xs: "11px", sm: "13px", md: "15px" },
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  padding: { xs: "4px 8px", sm: "5px 10px", md: "5px 10px" },
                  borderRadius: "5px",
                  display: "flex",
                  gap: { xs: "2px", sm: "5px", md: "5px" },
                }}
              >
                <Link
                  to="/"
                  style={{
                    fontSize: "inherit",
                    color: "white",
                    textDecoration: "none",
                    opacity: 0.7,
                  }}
                >
                  Home
                </Link>
                <span style={{ opacity: 0.7 }}>/</span>
                <span>My Account</span>
                <span style={{ opacity: 0.7 }}>/</span>
                <span>Ticket History</span>
              </Box>
      
              {/* Title with Button */}
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "white",
                  fontSize: { xs: "20px", sm: "25px", md: "30px" },
                  textAlign: "center",
                  fontWeight: 700,
                  textShadow: "2px 2px 8px rgba(0, 0, 0, 0.5)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: { xs: "10px", sm: "15px", md: "20px" },
                  width: "90%",
                }}
              >
                Ticket History
              </Box>
            </Box>
      <Container
        maxWidth="xl"
        sx={{
          // width: "90%",
          // backgroundColor: "#FFFFFF",
          // border: "2px solid #EBEBEB",
          // borderRadius: "10px",
          marginTop: "-75px",
          marginBottom: "50px",
          position: "relative",
          zIndex: 1,
          p: { xs: 2, sm: 3, md: 4 },
        }}
      >      
      <div style={{ width: "90%", margin: "0 auto" }}>
        <div style={{ padding: "30px", borderRadius: "10px", backgroundColor: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          {/* Header */}
          <div style={{ marginBottom: "30px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <h1 style={{ color: "#d32f2f", fontWeight: "bold", marginBottom: "8px", fontSize: "20px" }}>
                Support Tickets Management
              </h1>
              <p style={{ color: "#999", fontSize: "12px" }}>
                Total Tickets: {activeTab === "inquiry" ? tickets.length : orderTickets.length} | Displaying: {activeTab === "inquiry" ? paginatedTickets.length : paginatedOrderTickets.length}
              </p>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <button
                onClick={() => { setActiveTab("inquiry"); setCurrentPage(1); setSortField(null); setSortDirection("asc"); }}
                style={{
                  backgroundColor: activeTab === "inquiry" ? "#d32f2f" : "white",
                  color: activeTab === "inquiry" ? "white" : "#d32f2f",
                  padding: "8px 16px",
                  border: "2px solid #d32f2f",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                🔍 Inquiry Ticket
              </button>
              <button
                onClick={() => { setActiveTab("order"); setCurrentPage(1); setSortField(null); setSortDirection("asc"); }}
                style={{
                  backgroundColor: activeTab === "order" ? "#d32f2f" : "white",
                  color: activeTab === "order" ? "white" : "#d32f2f",
                  padding: "8px 16px",
                  border: "2px solid #d32f2f",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                🛒 Order Ticket
              </button>
              <button
                onClick={() => {
                  if (activeTab === "inquiry") {
                    fetchTickets();
                    tickets.forEach((ticket) => { fetchUnreadCount(ticket.ticketNumber); });
                  } else {
                    fetchOrderTickets();
                  }
                }}
                style={{
                  backgroundColor: "white",
                  color: "#d32f2f",
                  padding: "8px 16px",
                  border: "2px solid #d32f2f",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                title="Refresh tickets and notifications"
              >
                🔄 Refresh
              </button>
            </div>
          </div>

          {/* Loading State */}
          {(activeTab === "inquiry" ? loading : orderLoading) && (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
              <div style={{ width: "40px", height: "40px", border: "3px solid #d32f2f", borderTop: "3px solid transparent", borderRadius: "50%", margin: "0 auto", animation: "spin 1s linear infinite" }} />
              <p style={{ marginTop: "16px", color: "#666", fontSize: "14px" }}>Loading tickets...</p>
            </div>
          )}

          {/* Error State */}
          {(activeTab === "inquiry" ? error : orderError) && (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
              <div style={{ backgroundColor: "#ffebee", border: "1px solid #ef5350", color: "#c62828", padding: "16px", borderRadius: "4px", marginBottom: "16px" }}>
                {activeTab === "inquiry" ? error : orderError}
              </div>
              <button
                onClick={activeTab === "inquiry" ? fetchTickets : fetchOrderTickets}
                style={{
                  backgroundColor: "#d32f2f",
                  color: "white",
                  padding: "8px 16px",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Retry
              </button>
            </div>
          )}

          {/* Filters */}
          {!(activeTab === "inquiry" ? loading || error : orderLoading || orderError) && (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "25px", padding: "20px", backgroundColor: "#f9f9f9", borderRadius: "8px" }}>
              <div>
                <label style={{ color: "#666", fontWeight: "600", display: "block", marginBottom: "6px", fontSize: "12px" }}>SEARCH</label>
                <input
                  type="text"
                  placeholder="Search by ticket, subject, user..."
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setCurrentPage(1);
                  }}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "14px",
                    boxSizing: "border-box",
                  }}
                />
              </div>

              <div>
                <label style={{ color: "#666", fontWeight: "600", display: "block", marginBottom: "6px", fontSize: "12px" }}>TYPE</label>
                <select
                  value={filterType}
                  onChange={(e) => {
                    setFilterType(e.target.value);
                    setCurrentPage(1);
                  }}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "14px",
                    boxSizing: "border-box",
                  }}
                >
                  <option value="all">All Types</option>
                  <option value="inquiry">Inquiry</option>
                  <option value="order">Order Issue</option>
                  <option value="technical">Technical</option>
                  <option value="billing">Billing</option>
                  <option value="feedback">Feedback</option>
                </select>
              </div>

              <div>
                <label style={{ color: "#666", fontWeight: "600", display: "block", marginBottom: "6px", fontSize: "12px" }}>STATUS</label>
                <select
                  value={filterStatus}
                  onChange={(e) => {
                    setFilterStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "14px",
                    boxSizing: "border-box",
                  }}
                >
                  <option value="all">All Status</option>
                  <option value="open">Open</option>
                  <option value="in-progress">In Progress</option>
                  <option value="re-open">Re-Open</option>
                  <option value="closed">Closed</option>
                </select>
              </div>

              <div>
                <label style={{ color: "#666", fontWeight: "600", display: "block", marginBottom: "6px", fontSize: "12px" }}>PRIORITY</label>
                <select
                  value={filterPriority}
                  onChange={(e) => {
                    setFilterPriority(e.target.value);
                    setCurrentPage(1);
                  }}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "14px",
                    boxSizing: "border-box",
                  }}
                >
                  <option value="all">All Priority</option>
                  <option value="urgent">Urgent</option>
                  <option value="high">High</option>
                  <option value="medium">Medium</option>
                  <option value="low">Low</option>
                </select>
              </div>
            </div>
          )}

          {/* Table */}
          {!(activeTab === "inquiry" ? loading || error : orderLoading || orderError) && (activeTab === "inquiry" ? sortedFilteredTickets : sortedFilteredOrderTickets).length === 0 ? (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
              <h3 style={{ color: "#999", marginBottom: "16px", fontSize: "18px" }}>No tickets found</h3>
              <p style={{ color: "#ccc", fontSize: "14px" }}>Try adjusting your filters or search criteria</p>
            </div>
          ) : !(activeTab === "inquiry" ? loading || error : orderLoading || orderError) ? (
            <>
              <div style={{ overflowX: "auto" }}>
                {activeTab === "inquiry" ? (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#d32f2f" }}>
                      <th onClick={() => handleSort("ticketNumber")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "left", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Ticket #{getSortIcon("ticketNumber")}</th>
                      <th style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "left" }}>Subject</th>
                      <th style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "left" }}>Customer</th>
                      <th onClick={() => handleSort("type")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Type{getSortIcon("type")}</th>
                      <th onClick={() => handleSort("status")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Status{getSortIcon("status")}</th>
                      <th onClick={() => handleSort("priority")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Priority{getSortIcon("priority")}</th>
                      <th onClick={() => handleSort("date")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Date{getSortIcon("date")}</th>
                      <th style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedTickets.map((ticket) => (
                      <tr
                        key={ticket.id}
                        style={{
                          borderBottom: "1px solid #f0f0f0",
                          backgroundColor: "white",
                          cursor: "pointer",
                        }}
                        onClick={() => { setSelectedTicket(ticket); setShowDetails(true); }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#fafafa")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
                      >
                        <td style={{ fontWeight: "600", color: "#333", fontSize: "13px", padding: "12px" }}>{ticket.ticketNumber}</td>
                        <td style={{ fontSize: "13px", padding: "12px" }}>
                          <div style={{ fontWeight: "500", color: "#333" }}>{ticket.subject.substring(0, 30)}</div>
                          <div style={{ color: "#999", fontSize: "12px", marginTop: "4px" }}>ID: {ticket.id}</div>
                        </td>
                        <td style={{ fontSize: "13px", padding: "12px" }}>
                          <div style={{ fontWeight: "500", color: "#333" }}>{ticket.userName}</div>
                          <div style={{ color: "#999", fontSize: "12px", marginTop: "4px" }}>{ticket.userEmail}</div>
                        </td>
                        <td style={{ textAlign: "center", padding: "12px" }}>
                          <span style={{ backgroundColor: "#e3f2fd", color: "#1976d2", padding: "4px 8px", borderRadius: "4px", fontSize: "12px", fontWeight: "500" }}>
                            {getTypeText(ticket.type)}
                          </span>
                        </td>
                        <td style={{ textAlign: "center", padding: "12px" }}>
                          <span style={{ backgroundColor: getStatusColor(ticket.status), color: getStatusTextColor(ticket.status), padding: "4px 8px", borderRadius: "4px", fontSize: "12px", fontWeight: "600" }}>
                            {ticket.status}
                          </span>
                          {ticket.status === "closed" && ticket.ticketClosedBy && (
                            renderActorBadge(ticket.ticketClosedBy, ticket.ticketClosedByRole, "#d32f2f")
                          )}
                          {(ticket.status === "re-open" || ticket.status === "reopen") && ticket.reopenedBy && (
                            renderActorBadge(ticket.reopenedBy, ticket.reopenedByRole, "#9c27b0")
                          )}
                        </td>
                        <td style={{ textAlign: "center", padding: "12px" }}>
                          <span
                            style={{
                              backgroundColor: getPriorityColor(ticket.priority),
                              color: "white",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            {ticket.priority}
                          </span>
                        </td>
                        <td style={{ textAlign: "center", color: "#333", fontSize: "13px", padding: "12px" }}>📅 {formatDate(ticket.date)}</td>
                        <td style={{ textAlign: "center", padding: "12px" }} onClick={(e) => e.stopPropagation()}>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedTicket(ticket);
                              setShowDetails(true);
                            }}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#1976d2",
                              cursor: "pointer",
                              padding: "4px 8px",
                              fontSize: "18px",
                            }}
                            title="View Details"
                          >
                            👁️
                          </button>
                          <div style={{ position: "relative", display: "inline-block" }}>
                            <button
                              onClick={(e) => { e.stopPropagation(); handleOpenChat(ticket); }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#d32f2f",
                                cursor: "pointer",
                                padding: "4px 8px",
                                fontSize: "18px",
                              }}
                              title="Reply"
                            >
                              💬
                            </button>
                            {unreadCounts[ticket.ticketNumber] > 0 && (
                              <span style={{
                                position: "absolute",
                                top: "-2px",
                                right: "0px",
                                backgroundColor: "#d32f2f",
                                color: "white",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "11px",
                                fontWeight: "bold",
                                border: "2px solid white",
                              }}>
                                {unreadCounts[ticket.ticketNumber]}
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                ) : (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#d32f2f" }}>
                      <th onClick={() => handleSort("ticketNumber")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "left", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Ticket #{getSortIcon("ticketNumber")}</th>
                      <th style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "left" }}>Subject</th>
                      <th style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "left" }}>Customer</th>
                      <th onClick={() => handleSort("type")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Type{getSortIcon("type")}</th>
                      <th onClick={() => handleSort("status")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Status{getSortIcon("status")}</th>
                      <th onClick={() => handleSort("priority")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Priority{getSortIcon("priority")}</th>
                      <th onClick={() => handleSort("date")} style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center", cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}>Date{getSortIcon("date")}</th>
                      <th style={{ color: "white", fontWeight: "600", fontSize: "12px", padding: "12px", textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedOrderTickets.map((ticket) => (
                      <tr
                        key={ticket.id}
                        style={{ borderBottom: "1px solid #f0f0f0", backgroundColor: "white", cursor: "pointer" }}
                        onClick={() => { setSelectedTicket(ticket); setShowDetails(true); }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#fafafa")}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
                      >
                        <td style={{ fontWeight: "600", color: "#333", fontSize: "13px", padding: "12px" }}>{ticket.ticketNumber}</td>
                        <td style={{ fontSize: "13px", padding: "12px" }}>
                          <div style={{ fontWeight: "500", color: "#333" }}>{ticket.subject?.substring(0, 30)}</div>
                          <div style={{ color: "#999", fontSize: "12px", marginTop: "4px" }}>ID: {ticket.id}</div>
                        </td>
                        <td style={{ fontSize: "13px", padding: "12px" }}>
                          <div style={{ fontWeight: "500", color: "#333" }}>{ticket.userName}</div>
                          <div style={{ color: "#999", fontSize: "12px", marginTop: "4px" }}>{ticket.userEmail || "--"}</div>
                        </td>
                        <td style={{ textAlign: "center", padding: "12px" }}>
                          <span style={{ ...getOrderTypeBadgeStyle(ticket.type), padding: "4px 8px", borderRadius: "4px", fontSize: "12px", fontWeight: "500" }}>
                            {ticket.type}
                          </span>
                        </td>
                        <td style={{ textAlign: "center", padding: "12px" }}>
                          <span style={{ backgroundColor: getStatusColor(ticket.status), color: getStatusTextColor(ticket.status), padding: "4px 8px", borderRadius: "4px", fontSize: "12px", fontWeight: "600" }}>
                            {ticket.status}
                          </span>
                          {ticket.status === "closed" && ticket.ticketClosedBy && (
                            renderActorBadge(ticket.ticketClosedBy, ticket.ticketClosedByRole, "#d32f2f")
                          )}
                          {(ticket.status === "re-open" || ticket.status === "reopen") && ticket.reopenedBy && (
                            renderActorBadge(ticket.reopenedBy, ticket.reopenedByRole, "#9c27b0")
                          )}
                        </td>
                        <td style={{ textAlign: "center", padding: "12px" }}>
                          <span style={{ backgroundColor: getPriorityColor(ticket.priority), color: "white", padding: "4px 8px", borderRadius: "4px", fontSize: "12px", fontWeight: "500" }}>
                            {ticket.priority}
                          </span>
                        </td>
                        <td style={{ textAlign: "center", color: "#333", fontSize: "13px", padding: "12px" }}>📅 {formatDate(ticket.date)}</td>
                        <td style={{ textAlign: "center", padding: "12px" }} onClick={(e) => e.stopPropagation()}>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedTicket(ticket);
                              setShowDetails(true);
                            }}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#1976d2",
                              cursor: "pointer",
                              padding: "4px 8px",
                              fontSize: "18px",
                            }}
                            title="View Details"
                          >
                            👁️
                          </button>
                          <div style={{ position: "relative", display: "inline-block" }}>
                            <button
                              onClick={(e) => { e.stopPropagation(); handleOpenChat(ticket); }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#d32f2f",
                                cursor: "pointer",
                                padding: "4px 8px",
                                fontSize: "18px",
                              }}
                              title="Reply"
                            >
                              💬
                            </button>
                            {unreadCounts[ticket.ticketNumber] > 0 && (
                              <span style={{
                                position: "absolute",
                                top: "-2px",
                                right: "0px",
                                backgroundColor: "#d32f2f",
                                color: "white",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "11px",
                                fontWeight: "bold",
                                border: "2px solid white",
                              }}>
                                {unreadCounts[ticket.ticketNumber]}
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                )}
              </div>

              {/* Pagination */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 0", borderTop: "1px solid #f0f0f0" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <label style={{ color: "#666", fontSize: "14px" }}>Results per page:</label>
                  <select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(parseInt(e.target.value));
                      setCurrentPage(1);
                    }}
                    style={{
                      padding: "6px 10px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      fontSize: "14px",
                    }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                  </select>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <button
                    onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                    style={{
                      padding: "8px",
                      background: "white",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      cursor: currentPage === 1 ? "default" : "pointer",
                      opacity: currentPage === 1 ? 0.5 : 1,
                      fontSize: "16px",
                    }}
                  >
                    &lt;
                  </button>
                  <span style={{ color: "#666", fontSize: "14px" }}>
                    Page {currentPage} of {totalPages || 1}
                  </span>
                  <button
                    onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: "8px",
                      background: "white",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      cursor: currentPage === totalPages ? "default" : "pointer",
                      opacity: currentPage === totalPages ? 0.5 : 1,
                      fontSize: "16px",
                    }}
                  >
                    &gt;
                  </button>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
      </Container>

      {/* Ticket Details Modal */}
      {showDetails && selectedTicket && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={handleCloseDetailsDialog}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              width: "90%",
              maxWidth: "700px",
              maxHeight: "90vh",
              overflow: "auto",
              boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div
              style={{
                padding: "24px",
                borderBottom: "1px solid #f0f0f0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#d32f2f",
                color: "white",
              }}
            >
              <h2 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
                Ticket {selectedTicket.ticketNumber}
              </h2>
              <button
                onClick={handleCloseDetailsDialog}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "white",
                }}
              >
                x
              </button>
            </div>

            {/* Modal Content */}
            <div style={{ padding: "24px" }}>
              {/* Info Grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  marginBottom: "24px",
                }}
              >
                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: "#999",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    Subject
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    {selectedTicket.subject}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: "#999",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    Date
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    📅 {formatDate(selectedTicket.createdDate || selectedTicket.date)}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: "#999",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    Customer
                  </p>
                  <p
                    style={{
                      margin: "0 0 4px 0",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    {selectedTicket.userName}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12px",
                      color: "#666",
                    }}
                  >
                    {selectedTicket.userEmail}
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: "#999",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    Car Model
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#333",
                    }}
                  >
                    {selectedTicket.carModel}
                  </p>
                </div>
              </div>

              <hr
                style={{
                  margin: "24px 0",
                  border: "none",
                  borderTop: "1px solid #f0f0f0",
                }}
              />

              {/* Description */}
              <div>
                <p
                  style={{
                    margin: "0 0 8px 0",
                    fontSize: "11px",
                    color: "#999",
                    fontWeight: "600",
                    textTransform: "uppercase",
                  }}
                >
                  Description
                </p>
                <p
                  style={{
                    margin: "0 0 24px 0",
                    fontSize: "14px",
                    color: "#333",
                    lineHeight: "1.6",
                    backgroundColor: "#fafafa",
                    padding: "12px",
                    borderRadius: "4px",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  {selectedTicket.description}
                </p>
              </div>

              {/* Attachment (if any) */}
              {selectedTicket.attachmentFileName && (
                <div
                  style={{
                    backgroundColor: "#f0f7ff",
                    border: "1px solid #bbdefb",
                    padding: "12px",
                    borderRadius: "4px",
                    marginBottom: "24px",
                  }}
                >
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: "#1976d2",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    Attachment
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "13px",
                      color: "#333",
                    }}
                  >
                    📎 {selectedTicket.attachmentFileName}
                  </p>
                </div>
              )}

              {/* Status Info Cards */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "15px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#f9f9f9",
                    padding: "15px",
                    borderRadius: "4px",
                    textAlign: "center",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: "#999",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    Status
                  </p>
                  <span
                    style={{
                      backgroundColor: getStatusColor(selectedTicket.status),
                      color: getStatusTextColor(selectedTicket.status),
                      padding: "6px 12px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600",
                      display: "inline-block",
                    }}
                  >
                    {selectedTicket.status}
                  </span>
                </div>

                <div
                  style={{
                    backgroundColor: "#f9f9f9",
                    padding: "15px",
                    borderRadius: "4px",
                    textAlign: "center",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: "#999",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    Priority
                  </p>
                  <span
                    style={{
                      backgroundColor: getPriorityColor(selectedTicket.priority),
                      color: "white",
                      padding: "6px 12px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600",
                      display: "inline-block",
                    }}
                  >
                    {selectedTicket.priority}
                  </span>
                </div>

                <div
                  style={{
                    backgroundColor: "#f9f9f9",
                    padding: "15px",
                    borderRadius: "4px",
                    textAlign: "center",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  <p
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "11px",
                      color: "#999",
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    Type
                  </p>
                  <span
                    style={{
                      backgroundColor: "#e3f2fd",
                      color: "#1976d2",
                      padding: "6px 12px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600",
                      display: "inline-block",
                    }}
                  >
                    {getTypeText(selectedTicket.type)}
                  </span>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div
              style={{
                padding: "16px 24px",
                borderTop: "1px solid #f0f0f0",
                display: "flex",
                gap: "12px",
                justifyContent: "flex-end",
                backgroundColor: "#f9f9f9",
              }}
            >
              {/* Close Button for Inquiry Tickets (when open/in-progress/pending) */}
              {activeTab === "inquiry" && selectedTicket.status !== "closed" && (
                <button
                  onClick={handleCloseInquiryTicket}
                  disabled={closingInquiryTicket}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: closingInquiryTicket ? "#ccc" : "#ff5722",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: closingInquiryTicket ? "not-allowed" : "pointer",
                    fontSize: "13px",
                    fontWeight: "600",
                    opacity: closingInquiryTicket ? 0.7 : 1,
                  }}
                >
                  {closingInquiryTicket ? "Closing..." : "🔒 Close Ticket"}
                </button>
              )}
              
              {/* Reopen Button for Inquiry Tickets (when closed) */}
              {activeTab === "inquiry" && selectedTicket.status === "closed" && (
                <button
                  onClick={handleReopenInquiryTicket}
                  disabled={reopeningInquiryTicket}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: reopeningInquiryTicket ? "#ccc" : "#2e7d32",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: reopeningInquiryTicket ? "not-allowed" : "pointer",
                    fontSize: "13px",
                    fontWeight: "600",
                    opacity: reopeningInquiryTicket ? 0.7 : 1,
                  }}
                >
                  {reopeningInquiryTicket ? "Reopening..." : "🔓 Reopen Ticket"}
                </button>
              )}

              {/* Close Button for Order Tickets (when open) */}
              {activeTab === "order" && selectedTicket.status !== "closed" && (
                <button
                  onClick={handleCloseOrderTicket}
                  disabled={closingTicket}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: closingTicket ? "#ccc" : "#ff5722",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: closingTicket ? "not-allowed" : "pointer",
                    fontSize: "13px",
                    fontWeight: "600",
                    opacity: closingTicket ? 0.7 : 1,
                  }}
                >
                  {closingTicket ? "Closing..." : "🔒 Close Ticket"}
                </button>
              )}
              
              {/* Reopen Button for Order Tickets (when closed) */}
              {activeTab === "order" && selectedTicket.status === "closed" && (
                <button
                  onClick={handleReopenOrderTicket}
                  disabled={reopeningTicket}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: reopeningTicket ? "#ccc" : "#2e7d32",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: reopeningTicket ? "not-allowed" : "pointer",
                    fontSize: "13px",
                    fontWeight: "600",
                    opacity: reopeningTicket ? 0.7 : 1,
                  }}
                >
                  {reopeningTicket ? "Reopening..." : "🔓 Reopen Ticket"}
                </button>
              )}
              
              <button
                onClick={() => {
                  handleCloseDetailsDialog();
                  handleOpenChat(selectedTicket);
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "white",
                  color: "#d32f2f",
                  border: "1px solid #d32f2f",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >
                💬 Open Chat
              </button>
              <button
                onClick={handleCloseDetailsDialog}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "white",
                  color: "#d32f2f",
                  border: "1px solid #d32f2f",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Chat Dialog with API Integration */}
      {showReplyChat && selectedTicket && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 }}>
          <div style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 16px rgba(0,0,0,0.15)", maxWidth: "700px", width: "90%", maxHeight: "90vh", display: "flex", flexDirection: "column" }}>
            {/* Header */}
            <div style={{ backgroundColor: "#d32f2f", color: "white", padding: "24px", fontWeight: "600", fontSize: "18px", display: "flex", justifyContent: "space-between", alignItems: "center", borderRadius:"10px" }}>
              <div>
                <p style={{ margin: 0 }}>{selectedTicket.ticketNumber}</p>
                <p style={{ fontSize: "12px", color: "#ffebee", margin: "4px 0 0 0" }}>{selectedTicket.subject}</p>
              </div>
              <button
                onClick={handleCloseChat}
                style={{ background: "none", border: "none", color: "white", cursor: "pointer", fontSize: "24px" }}
              >
                x
              </button>
            </div>

            {/* Chat Messages */}
            <div style={{ flex: 1, backgroundColor: "#fafafa", padding: "24px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "12px", zIndex: "1000" }}>
              {loadingChat && (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <div style={{ width: "30px", height: "30px", border: "2px solid #d32f2f", borderTop: "2px solid transparent", borderRadius: "50%", margin: "0 auto", animation: "spin 1s linear infinite" }} />
                  <p style={{ color: "#666", fontSize: "12px", marginTop: "8px" }}>Loading messages...</p>
                </div>
              )}

              {chatError && (
                <div style={{ backgroundColor: "#ffebee", border: "1px solid #ef5350", color: "#c62828", padding: "12px", borderRadius: "4px", fontSize: "12px" }}>
                  {chatError}
                </div>
              )}

              {!loadingChat && chatMessages.length === 0 && !chatError && (
                <div style={{ textAlign: "center", color: "#999", padding: "20px", fontSize: "13px" }}>
                  No messages yet. Start a conversation!
                </div>
              )}

              {chatMessages.map((msg) => (
                <div key={msg.chatId} style={{ display: "flex", justifyContent: msg.senderType === "USER" ? "flex-end" : "flex-start", alignItems: "flex-end", gap: "8px" }}>
                  {msg.senderType !== "USER" && (
                    <div style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: "#d32f2f", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <SupportAgentIcon style={{ fontSize: "18px", color: "white" }} />
                    </div>
                  )}
                  <div
                    style={{
                      maxWidth: "75%",
                      padding: "12px 16px",
                      backgroundColor: msg.senderType === "USER" ? "#e3f2fd" : getSenderBgColor(msg.senderType),
                      borderRadius: "8px",
                      border: `1px solid ${msg.senderType === "USER" ? "#bbdefb" : "#f0f0f0"}`,
                    }}
                  >
                    <p style={{ fontWeight: "600", fontSize: "12px", margin: 0, color: getSenderColor(msg.senderType) }}>
                      {msg.senderType === "USER" ? msg.senderFullName : `${msg.senderFullName} (Support)`}
                    </p>
                    {msg.message && (
                      <p style={{ marginTop: "6px", color: "#333", fontSize: "13px", lineHeight: "1.5", wordBreak: "break-word" }}>
                        {msg.message}
                      </p>
                    )}
                    {msg.attachmentFileName && (
                      <button
                        onClick={() => handleDownloadAttachment(msg.chatId, msg.attachmentFileName, selectedTicket?.ticketNumber?.startsWith("ORT-") || selectedTicket?.orderRefId !== undefined)}
                        disabled={isDownloading[msg.chatId]}
                        style={{
                          display: "inline-block",
                          marginTop: "8px",
                          padding: "6px 10px",
                          backgroundColor: "#1976d2",
                          color: "white",
                          textDecoration: "none",
                          borderRadius: "4px",
                          fontSize: "11px",
                          fontWeight: "500",
                          border: "none",
                          cursor: isDownloading[msg.chatId] ? "not-allowed" : "pointer",
                          opacity: isDownloading[msg.chatId] ? 0.6 : 1,
                        }}
                      >
                        📎 {isDownloading[msg.chatId] ? "Downloading..." : msg.attachmentFileName}
                      </button>
                    )}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "6px" }}>
                      <p style={{ color: "#999", fontSize: "11px", margin: 0 }}>
                        {formatChatTime(msg.formattedDateTime)}
                      </p>
                      {msg.senderType === "USER" && (
                        <div style={{ marginLeft: "8px" }}>
                          {getMessageStatusIndicator(msg)}
                        </div>
                      )}
                    </div>
                  </div>
                  {msg.senderType === "USER" && (
                    <div style={{ width: "32px", height: "32px", borderRadius: "50%", overflow: "hidden", flexShrink: 0, backgroundColor: "#e3f2fd", display: "flex", alignItems: "center", justifyContent: "center", border: "2px solid #bbdefb" }}>
                      {userProfilePic ? (
                        <img src={userProfilePic} alt="profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      ) : (
                        <PersonIcon style={{ fontSize: "20px", color: "#1976d2" }} />
                      )}
                    </div>
                  )}
                </div>
              ))}
              <div ref={chatEndRef} />
            </div>

            {/* Message Input */}
            <div style={{ borderTop: "1px solid #f0f0f0", padding: "16px 24px", display: "flex", flexDirection: "column", gap: "10px" }}>
              {attachedFile && (
                <div style={{ fontSize: "12px", color: "#666", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px", backgroundColor: "#e3f2fd", borderRadius: "4px" }}>
                  <span>📎 Attached: {attachedFile.name}</span>
                  <button
                    onClick={() => {
                      setAttachedFile(null);
                      if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                      }
                    }}
                    style={{ background: "none", border: "none", color: "#d32f2f", cursor: "pointer", fontSize: "16px" }}
                  >
                    x
                  </button>
                </div>
              )}

              <div style={{ display: "flex", gap: "12px", alignItems: "flex-end" }}>
                <textarea
                  value={replyMessage}
                  onChange={(e) => setReplyMessage(e.target.value)}
                  placeholder={attachedFile ? "Add a caption..." : "Type your reply..."}
                  style={{
                    flex: 1,
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    fontSize: "13px",
                    minHeight: "60px",
                    fontFamily: "inherit",
                    resize: "vertical",
                    boxSizing: "border-box",
                  }}
                />

                <label
                  htmlFor="file-upload"
                  style={{
                    padding: "8px 12px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "18px",
                    whiteSpace: "nowrap",
                    height: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    transition: "background-color 0.2s ease",
                  }}
                  title="Attach file (Max 5MB)"
                >
                  <AttachFileIcon sx={{ fontSize: "20px", color: "#666" }} />
                  <input
                    id="file-upload"
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </label>

                <button
                  onClick={handleSendReply}
                  disabled={(!replyMessage.trim() && !attachedFile) || sendingMessage}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#d32f2f",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    fontWeight: "600",
                    cursor: "pointer",
                    opacity: (!replyMessage.trim() && !attachedFile) || sendingMessage ? 0.5 : 1,
                    fontSize: "14px",
                  }}
                >
                  {sendingMessage ? "Sending..." : "Send"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Toast */}
      {showSuccess && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            backgroundColor: successMessage.includes("Failed") ? "#f44336" : "#4caf50",
            color: "white",
            padding: "16px 24px",
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            gap: "12px",
            fontSize: "14px",
          }}
        >
          v {successMessage}
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
      <FooterManual />
    </div>
  );
};

export default HistoryTickets;